module.exports = __webpack_public_path__ + "img/spritz-glasses.f75e35f5.jpg";